export class MedicalExamCertificateExemption {
    public exemptionTypeId: number;
    public effectiveDate: Date;
    public expirationDate: Date;
}
